module.exports = __webpack_public_path__ + "img/ar_flag.6bac2f15.png";